import { render, staticRenderFns } from "./thresholdReminder.vue?vue&type=template&id=9d6be6ce&"
import script from "./thresholdReminder.vue?vue&type=script&lang=js&"
export * from "./thresholdReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports